import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { CreateOrganizationRequest } from '@/definitions/organization'
import { CreateOrganization } from '@/services/OrganizationService'
import { MINIMUM_PROVISIONING_MS, withMinimumDuration } from '@/utils/minimumDuration'

export const useCreateOrganization = () => {
  const queryClient = useQueryClient()

  return useMutation({
    // The floor is held here rather than at the call site so the mutation's own
    // pending state covers the whole wait a caller is showing progress for.
    mutationFn: (data: CreateOrganizationRequest) =>
      withMinimumDuration(CreateOrganization(data), MINIMUM_PROVISIONING_MS),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['organizations'] })
    },
  })
}
